import { queryClient } from 'main'
import type { Company } from 'resources/types'
import { LS_KEY, QK } from 'shared/hooks/useSelectedCompany'

export function getSelectedCompany(): Company | undefined {
	const cached = queryClient.getQueryData(QK) as Company | undefined
	if (cached !== undefined) return cached
	const raw = localStorage.getItem(LS_KEY)
	return raw ? (JSON.parse(raw) as Company) : undefined
}

export function setSelectedCompany(company: Company | undefined) {
	if (company) localStorage.setItem(LS_KEY, JSON.stringify(company))
	else localStorage.removeItem(LS_KEY)
	queryClient.setQueryData(QK, company)
}

export function getSelectedCompanyId(): string | undefined {
	return getSelectedCompany()?.id
}
